import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FexidocLogo } from "@/components/FexidocLogo";
import { useAuth } from "@/lib/auth";
import { GoogleSignInButton } from "@/components/GoogleSignInButton";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState(""); const [pw, setPw] = useState(""); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await login(email, pw); nav("/app"); toast.success("Welcome back."); }
    catch (err) { toast.error(err?.response?.data?.detail || "Invalid email or password."); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><Link to="/"><FexidocLogo size={32}/></Link></div>
        <div className="fx-panel p-8">
          <h1 className="font-display text-2xl font-bold text-white">Sign in</h1>
          <p className="text-sm text-slate-400 mt-1">Welcome back to Fexidoc.</p>
          <div className="mt-6"><GoogleSignInButton /></div>
          <div className="flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-[#1E293B]" />
            <span className="text-[11px] uppercase tracking-widest text-slate-500">or use email</span>
            <div className="flex-1 h-px bg-[#1E293B]" />
          </div>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <Field label="Email" type="email" value={email} onChange={setEmail} testid="login-email"/>
            <Field label="Password" type="password" value={pw} onChange={setPw} testid="login-password"/>
            <div className="text-right -mt-2"><Link to="/forgot-password" className="text-xs text-cyan-300 hover:text-cyan-200" data-testid="forgot-link">Forgot password?</Link></div>
            <button disabled={busy} className="fx-btn-primary w-full text-white font-medium py-2.5 rounded-lg disabled:opacity-60" data-testid="login-submit">{busy?"Signing in…":"Sign in"}</button>
          </form>
          <div className="mt-6 text-sm text-slate-400 text-center">New to Fexidoc? <Link to="/signup" className="text-cyan-300 hover:text-cyan-200">Create an account</Link></div>
        </div>
      </div>
    </div>
  );
}

function Field({label, value, onChange, type="text", testid}) {
  return (
    <label className="block">
      <div className="text-xs text-slate-400 mb-1">{label}</div>
      <input required type={type} value={value} onChange={(e)=>onChange(e.target.value)} className="w-full bg-[#0D1224] border border-[#1E293B] rounded-lg px-3 py-2 text-sm text-slate-100 focus:border-cyan-400 outline-none" data-testid={testid}/>
    </label>
  );
}
